import { useActions, useAppSelector } from '@/hooks'
import { stateDeviceSelector } from '@/modules/aqua-device-module/store/stateSlice'
import cn from '@/utils/cn'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { Box } from '@mui/material'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useGetUnitsListMutation } from '@/modules/devices-list/services/newUnitsListService'
import { filterSystemSelector } from '@/store/filterSystemsSlise'

const s = cn('device-module-calendar')
const Calendar = () => {
  const { startDate, endDate } = useAppSelector(filterSystemSelector)
  const { setStartDate, setEndDate } = useActions()
  return (
    <Box
      display='flex'
      alignItems='center'
      gap={{ xss: 0, md: 1 }}
      className={s()}
      sx={{
        width: 315,
        zIndex: 9999999,
      }}
    >
      <DatePicker.RangePicker
        showTime
        allowClear={false}
        // disabled={isLoadingSearch}
        variant={'borderless'}
        style={{ width: 315, zIndex: 9999999 }}
        value={[startDate, endDate]}
        format='DD.MM.YYYY HH:mm'
        suffixIcon={
          <CalendarMonthIcon
            htmlColor={'dark-gray'}
            fontSize='medium'
          />
        }
        onChange={(e) => {
          setStartDate(dayjs(e ? e[0] : startDate))
          setEndDate(dayjs(e ? e[1] : endDate))
        }}
      />
    </Box>
  )
}

export default Calendar
